// extracted by mini-css-extract-plugin
export var colorSquare = "_qd-0";
export var danger = "_qd-5";
export var lightPink = "_qd-8";
export var neutralBlue = "_qd-7";
export var neutralYellow = "_qd-6";
export var normal = "_qd-1";
export var primary = "_qd-2";
export var primaryLight = "_qd-3";
export var solidBlack = "_qd-g";
export var solidGreen = "_qd-b";
export var solidLightBlue = "_qd-d";
export var solidNavy = "_qd-c";
export var solidOrange = "_qd-f";
export var solidPink = "_qd-e";
export var solidRed = "_qd-9";
export var solidYellow = "_qd-a";
export var success = "_qd-4";